<template>
  <UbicationTechAssistanceWrapper v-if="showDetail" />
</template>

<script>
import UbicationTechAssistanceWrapper from './_components/UbicationTechAssistanceWrapper';

import store from '@/store/index';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'UbicationTechAssistance',
  mixins: [alert],
  provide() {
    return {
      studentSieId: store.getters['$_student/StudentSie'],
      tapRequestId: this.tapRequestId,
    };
  },
  data: () => ({ showDetail: false, tapRequestId: null }),
  components: { UbicationTechAssistanceWrapper },
  methods: {
    async initTapRequest() {
      await this.$store.dispatch('ubication-tech-assistance-mngmt/resetAll');
      this.showDetail = !this.showDetail;
    },
    goBack() {
      this.$router.push({ path: '/pei' });
    },
  },
  async created() {
    if (store.getters.IsValidSelectedStudent) {
      this.initTapRequest();
    } else {
      this.goBack();
    }
  },
};
</script>

<style scoped>
.disabled-page {
  pointer-events: none;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
@media screen and (max-width: 765px) {
  .tag-badge-title {
    font-size: 18px;
  }
}
.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.signed,
.border-box.unsigned {
  border-radius: 0px 0px 5px 5px;
  border-top: none;
  padding: 0 !important;
  height: 65px;
}
.border-box.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}

.signed {
  background-color: #2db782;
  color: white;
}
.unsigned {
  background-color: #f7f7f7;
  color: black;
}
.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

.row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.text-fix {
  font-weight: 400;
}
.relative-top-10 {
  position: relative;
  top: 0.8em;
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}
.blured-body {
  backdrop-filter: blur(8px);
}
</style>
